import { Input, Directive } from '@angular/core';
import { PageInstance } from '@workflow/class/page.service';
import { FlowInstance } from '@workflow/class/flow.service';

@Directive()
export class PageElementBaseComponent {
  /**
   * Dynamic Page object.
   */
  @Input()
  public page: PageInstance;

  /**
   * Dynamic Page object.
   */
  @Input()
  public flow: FlowInstance;
}
